<template>
    <label class="switch">
        <input type="checkbox" v-model="state" :checked="state">
        <span class="slider round"></span>
    </label>
</template>

<script>
    export default {
        name: "MJSliderButton",
        data() {
            return {
                state: false
            }
        },
        watch: {
            state(value) {
                this.$emit("input", value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/color_palette";

    $knob-size: 27px;
    $knob-position-bottom: 2px;
    $knob-position-left: 2px;
    $input-height: 31px;
    $input-width: 51px;
    .switch {
        position: relative;
        display: inline-block;
        width: $input-width;
        height: $input-height;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: black("10");
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: $knob-size;
        width: $knob-size;
        left: $knob-position-left;
        bottom: $knob-position-bottom;
        border: 0.5px solid rgba(0, 0, 0, 0.04);
        box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15),
        0 3px 1px 0 rgba(0, 0, 0, 0.06);
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: blue("100");
    }

    input:focus + .slider {
        box-shadow: 0 0 1px blue("100");
    }

    input:checked + .slider:before {
        -webkit-transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
        -ms-transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
        transform: translateX($input-width - ($knob-size + $knob-position-left * 2));
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: $knob-size;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>